// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"673":"88351bb2","767":"b0ae55e6"}[chunkId] + ".chunk.js";
};